export const LOAD_PAYMENT_METHODS = 'settings/LOAD_PAYMENT_METHODS';
export const LOAD_PAYMENT_METHODS_SUCCESS = 'settings/LOAD_PAYMENT_METHODS_SUCCESS';
export const LOAD_PAYMENT_METHODS_ERROR = 'settings/LOAD_PAYMENT_METHODS_ERROR';
export const SAVE_PAYMENT_METHOD_REQUEST = 'settings/SAVE_PAYMENT_METHOD_REQUEST';
export const REMOVE_PAYMENT_METHOD_REQUEST =
  'settings/REMOVE_PAYMENT_METHOD_REQUEST';
